// graph.js
google.charts.load("current", { packages: ["corechart"] });
google.charts.setOnLoadCallback(drawCharts);

function drawCharts() {
  var barData = google.visualization.arrayToDataTable([
    ["(単位：億円)", "受託残高(AUM)", "累計AUM"],
    ["2022/10", 86, 86],
    ["2023/3", 374, 374],
    ["2023/9", 399.49, 399.49],
    ["2024/3", 648, 648],
    ["2024/9", 915, 915],
  ]);

  var barOptions = {
    focusTarget: "none",
    backgroundColor: "transparent",
    colors: ["#1D59B1", "#8CB2EB"],
    chartArea: {
      left: 50,
      top: 10,
      width: "100%",
      height: "70%",
    },
    bar: {
      groupWidth: "30%",
    },
    hAxis: {
      textStyle: {
        fontSize: 11,
      },
    },
    vAxis: {
      minValue: 0,
      maxValue: 1000,
      baselineColor: "#DDD",
      gridlines: {
        color: "#DDD",
        count: 6,
      },
      textStyle: {
        fontSize: 11,
      },
    },
    legend: {
      position: "bottom",
      textStyle: {
        fontSize: 12,
      },
    },
    animation: {
      duration: 1200,
      easing: "out",
      startup: true,
    },
  };

  var barChart = new google.visualization.ColumnChart(
    document.getElementById("bar__chart")
  );
  barChart.draw(barData, barOptions);
}

google.charts.load("current", { packages: ["corechart"] });
google.charts.setOnLoadCallback(drawChartsEn);

function drawChartsEn() {
  var barData = google.visualization.arrayToDataTable([
    ["Unit: 100 million yen", "Assets Under Management (AUM)", "Cumulative AUM"],
    ["2022/10", 86, 86],
    ["2023/3", 374, 374],
    ["2023/9", 399.49, 399.49],
    ["2024/3", 648, 648],
    ["2024/9", 915, 915],
  ]);

  var barOptions = {
    focusTarget: "none",
    backgroundColor: "transparent",
    colors: ["#1D59B1", "#8CB2EB"],
    chartArea: {
      left: 50,
      top: 10,
      width: "100%",
      height: "70%",
    },
    bar: {
      groupWidth: "30%",
    },
    hAxis: {
      textStyle: {
        fontSize: 11,
      },
    },
    vAxis: {
      minValue: 0,
      maxValue: 1000,
      baselineColor: "#DDD",
      gridlines: {
        color: "#DDD",
        count: 6,
      },
      textStyle: {
        fontSize: 11,
      },
    },
    legend: {
      position: "bottom",
      textStyle: {
        fontSize: 12,
      },
    },
    animation: {
      duration: 1200,
      easing: "out",
      startup: true,
    },
  };

  var barChart = new google.visualization.ColumnChart(
    document.getElementById("bar__chart-en")
  );
  barChart.draw(barData, barOptions);
}
